export default "__VITE_ASSET__Nwi6fpHz__"